import { makeStyles } from '@mui/styles';

const ACCENT = "#d4163c";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    overflow: "hidden",
    "@media (max-width: 780px)": { width: "45%" },
    "&:hover": { transform: 'scale(1.05)' },
  },
  bigCard: {
    position: "relative",
    overflow: "hidden",
    "@media (max-width: 780px)": { width: "100%" },
  },
  cardContainer: {
    height: "100%",
    display: "block",
    position: "relative",
    overflow: "hidden",
    borderRadius: 14,
    background: "#15151a",
    border: "1px solid rgba(255,255,255,0.06)",
    boxShadow: "0 4px 18px rgba(0,0,0,.45)",
    cursor: "pointer",
    transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      borderColor: ACCENT,
      boxShadow: "0 10px 28px rgba(212,22,60,.28)",
    },
  },
  cardImage: {
    position: "relative",
    display: "block",
    width: "100%",
    aspectRatio: 0.6757,
    objectFit: "cover",
  },
  tag: { position: "relative" },
  tagMembership: {
    "&::before": {
      position: "absolute",
      top: 10,
      left: 10,
      width: "auto",
      height: "auto",
      zIndex: 2,
      padding: "3px 9px",
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: 1.4,
      letterSpacing: ".08em",
      color: "white",
    },
  },
  tagVip: {
    "&::before": {
      background: `linear-gradient(135deg, ${ACCENT}, #8f0f2a)`,
      content: '"VIP"',
    },
  },
  tagTop: {
    "&::before": {
      background: "linear-gradient(135deg, #ffd478, #e0a93b)",
      color: "#1a1a1a",
      content: '"TOP"',
    },
  },
  tagFree: {
    "&::before": {
      background: "rgba(60,60,66,.9)",
      content: '"FREE"',
    },
  },
  tagProfileStatus: {
    "&::before": {
      position: "absolute",
      top: 10,
      right: 10,
      left: "auto",
      bottom: "auto",
      width: "auto",
      height: "auto",
      zIndex: 2,
      padding: "3px 9px",
      borderRadius: 999,
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1.4,
      letterSpacing: ".06em",
      color: "white",
    },
  },
  tagVerified: {
    "&::before": {
      content: '"\\2713\\00a0VERIFIED"',
      background: "rgba(34,160,60,.92)",
    },
  },
  tagNotVerified: {
    "&::before": { display: "none" },
  },
  cardOverlay: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    padding: "42px 12px 12px",
    textAlign: "left",
    background: "linear-gradient(to top, rgba(0,0,0,.88) 0%, rgba(0,0,0,.55) 55%, rgba(0,0,0,0) 100%)",
  },
  cardName: {
    color: "#fff",
    fontSize: "1.05rem",
    fontWeight: 600,
    letterSpacing: ".03em",
    lineHeight: 1.25,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    '@media (max-width: 960px)': { fontSize: ".95rem" },
  },
  cardCity: {
    color: "rgba(255,255,255,.72)",
    fontSize: ".8rem",
    fontWeight: 400,
    marginTop: 2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cardTextContainer: {
    textAlign: "center",
    fontSize: "1.2rem",
    letterSpacing: ".1rem",
    lineHeight: "1.5rem",
    fontWeight: 500,
    color: "#e8e8ec",
    border: "1px solid rgba(255,255,255,.08)",
    padding: "5px",
  },
  lazzo: {
    position: "absolute",
    backgroundColor: "white",
    width: 300,
    textAlign: "center",
    top: "5%",
    right: "50%",
    padding: "3px 0px",
    transform: "rotate(-45deg)",
  },
  smallLazzo: {
    position: "absolute",
    backgroundColor: "white",
    width: 300,
    textAlign: "center",
    top: "10%",
    right: "5%",
    padding: "3px 0px",
    transform: "rotate(-45deg)",
  },
  starContainer: {
    position: "absolute",
    right: 0,
    bottom: 0,
    padding: 10,
    color: "white",
  },
}));

export { useStyles };
